import {computed, Ref} from "vue";
import {LoyaltyCardMembership} from "@/loyalty-card/interfaces/hds/LoyaltyCard";
import {MembershipProgress, membershipProgress} from "@/loyalty-card-membership/services/membershipProgress";

/**
 * Reactive view of {@link membershipProgress}: one computed per field, so the
 * screens can destructure what they read.
 *
 * @param membership The reactive membership reference.
 */
export default function useMembershipProgress(membership: Ref<LoyaltyCardMembership>) {
    const progress = computed(() => membershipProgress(membership.value));
    const field = <K extends keyof MembershipProgress>(key: K) => computed(() => progress.value[key]);

    return {
        activeObjective: field("activeObjective"),
        isProduct: field("isProduct"),
        isPoint: field("isPoint"),
        isStampCard: field("isStampCard"),
        productThreshold: field("productThreshold"),
        productProgress: field("productProgress"),
        productRemaining: field("productRemaining"),
        productOverflow: field("productOverflow"),
        rewardsReady: field("rewardsReady"),
        canOffer: field("canOffer"),
        nearThreshold: field("nearThreshold"),
        offerHighlighted: field("offerHighlighted"),
        advanceDebt: field("advanceDebt"),
        pointThreshold: field("pointThreshold"),
        pointProgress: field("pointProgress"),
        pointRemaining: field("pointRemaining"),
        ruleTeaser: field("ruleTeaser"),
        rewardAvailable: field("rewardAvailable"),
        fillLabel: field("fillLabel")
    };
}
